import React from 'react';
import './MyBadge.scss';
import PropTypes from 'prop-types';

const MyBadge = ({ color, children }) => {
  return <div className={`my-badge b-${color} rounded-4`}>{children}</div>;
};

MyBadge.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
};

export default MyBadge;
